/**
 * The words of saved views (docs/list-standard.md §8.1): the menu at the start of a list's toolbar,
 * its dialog, and identity's refusals (`identity.refusal.view.*`, list-views.rules.ts). Kept beside
 * the catalogue and spread into it, so a parallel change to the catalogue does not collide with these.
 */
export const SAVED_VIEWS_EN = {
    'views.menu': 'Views of this list: {name}',
    'views.all': 'All records',
    'views.default': 'opens by default',
    'views.sharedByYou': 'shared by you',
    'views.sharedBy': 'shared by {name}',
    'views.modified': 'Changed since this view was opened',
    'views.saveAs': 'Save as a new view…',
    'views.saveChanges': 'Save changes to «{name}»',
    'views.rename': 'Rename or share…',
    'views.makeDefault': 'Open this list on this view',
    'views.clearDefault': 'Stop opening this list on this view',
    'views.remove': 'Remove «{name}»',
    'views.removed': '«{name}» was removed.',
    'views.undo': 'Undo',
    'views.dialog.new': 'Save this view',
    'views.dialog.rename': 'Rename this view',
    'views.dialog.lede': 'Keeps the tab, search, filters, order and layout you see now, to open again with one press.',
    'views.name': 'Name',
    'views.name.required': 'Give the view a name.',
    'views.share': 'Share with everyone in the workspace',
    'views.save': 'Save',
    'identity.refusal.view.screen': 'This list cannot keep views.',
    'identity.refusal.view.name': 'A view\'s name is 1 to {max} characters.',
    'identity.refusal.view.taken': 'You already have a view called «{name}» on this list.',
    'identity.refusal.view.full': 'This list keeps at most {max} views of yours. Remove one first.',
    'identity.refusal.view.share': 'Sharing a view with the workspace needs the permission to share views.',
    'identity.refusal.view.not_yours': 'This view was shared by someone else; they, or whoever may share views, can change it.',
    'identity.refusal.view.missing': 'This view no longer exists.',
    'identity.refusal.view.stale': 'This view was changed elsewhere. Reload the list and try again.',
    'identity.refusal.view.expired': 'A removed view can be put back for {days} days.',
    'identity.refusal.view.size': 'This view holds more than a view can keep.',
    'identity.refusal.view.conditions': 'A view keeps at most {max} conditions.',
    'identity.refusal.view.depth': 'Conditions are grouped one level deep, no more.',
    'change.field.list_view.screen': 'List',
    'change.field.list_view.owner_id': 'Saved by',
    'change.field.list_view.name': 'View name',
    'change.field.list_view.shared': 'Shared with the workspace',
    'change.field.list_view.spec': 'What the view shows',
    'change.field.list_view.deleted_at': 'Removed at',
    'change.field.list_view.deleted_by': 'Removed by',
    'change.field.list_view_default.screen': 'List',
    'change.field.list_view_default.view_id': 'View the list opens on',
};
export const SAVED_VIEWS_AR = {
    'views.menu': 'طرق عرض هذه القائمة: {name}',
    'views.all': 'كل السجلات',
    'views.default': 'تُفتح بها القائمة',
    'views.sharedByYou': 'شاركتَها',
    'views.sharedBy': 'شاركها {name}',
    'views.modified': 'تغيّرت منذ فتحها',
    'views.saveAs': 'حفظ كطريقة عرض جديدة…',
    'views.saveChanges': 'حفظ التغييرات على «{name}»',
    'views.rename': 'إعادة التسمية أو المشاركة…',
    'views.makeDefault': 'افتح القائمة بهذه الطريقة',
    'views.clearDefault': 'لا تفتح القائمة بهذه الطريقة',
    'views.remove': 'حذف «{name}»',
    'views.removed': 'حُذفت «{name}».',
    'views.undo': 'تراجع',
    'views.dialog.new': 'حفظ طريقة العرض',
    'views.dialog.rename': 'إعادة تسمية طريقة العرض',
    'views.dialog.lede': 'تحفظ التبويب والبحث والتصفية والترتيب والشكل الظاهر الآن، لتفتحها مرة أخرى بضغطة.',
    'views.name': 'الاسم',
    'views.name.required': 'اكتب اسمًا لطريقة العرض.',
    'views.share': 'مشاركتها مع كل أعضاء مساحة العمل',
    'views.save': 'حفظ',
    'identity.refusal.view.screen': 'هذه القائمة لا تحفظ طرق عرض.',
    'identity.refusal.view.name': 'اسم طريقة العرض من حرف إلى {max} حرفًا.',
    'identity.refusal.view.taken': 'لديك طريقة عرض باسم «{name}» على هذه القائمة.',
    'identity.refusal.view.full': 'تحفظ القائمة {max} طريقة عرض لك على الأكثر. احذف واحدة أولًا.',
    'identity.refusal.view.share': 'مشاركة طريقة عرض مع مساحة العمل تحتاج صلاحية مشاركة طرق العرض.',
    'identity.refusal.view.not_yours': 'شارك هذه الطريقة شخص آخر، ويغيّرها هو أو من يملك صلاحية المشاركة.',
    'identity.refusal.view.missing': 'لم تعد طريقة العرض هذه موجودة.',
    'identity.refusal.view.stale': 'تغيّرت طريقة العرض من مكان آخر. أعد تحميل القائمة وحاول مجددًا.',
    'identity.refusal.view.expired': 'تُستعاد طريقة العرض المحذوفة خلال {days} يومًا فقط.',
    'identity.refusal.view.size': 'طريقة العرض هذه أكبر مما يُحفظ.',
    'identity.refusal.view.conditions': 'تحفظ طريقة العرض {max} شرطًا على الأكثر.',
    'identity.refusal.view.depth': 'تُجمَّع الشروط في مستوى واحد لا أكثر.',
    'change.field.list_view.screen': 'القائمة',
    'change.field.list_view.owner_id': 'حفظها',
    'change.field.list_view.name': 'اسم طريقة العرض',
    'change.field.list_view.shared': 'مشاركة مع مساحة العمل',
    'change.field.list_view.spec': 'ما تعرضه',
    'change.field.list_view.deleted_at': 'وقت الحذف',
    'change.field.list_view.deleted_by': 'حذفها',
    'change.field.list_view_default.screen': 'القائمة',
    'change.field.list_view_default.view_id': 'طريقة العرض التي تُفتح بها القائمة',
};
//# sourceMappingURL=i18n-saved-views.js.map